<template>
<div class="Navbar">
		<router-link class="Navbar_logo" to="/"></router-link>

    <div class="Navbar_item">
        <ul>
			<li>
                <router-link to="/">全部</router-link>
            </li>
            <li>
                <router-link to="/product/calendar">年曆</router-link>
            </li>
            <li>
                <router-link to="/product/postcard">明信片</router-link>
            </li>
            <li>
                <router-link to="/product/zine">Zine</router-link>
            </li>
            <li>
                <router-link to="/product/sticker">貼紙</router-link>
            </li>
            <li class="cart">
                <router-link to="/cart"><font-awesome-icon icon="shopping-cart"/> {{CartItemSum}}</router-link>
            </li>
        </ul>
    </div>
</div>
</template>

<script>
import { mapState, mapGetters,mapMutations, mapActions} from 'vuex'
export default {
		computed:{
        ...mapState({
			CartItems: state=>state.cart.CartItems,
		...mapGetters('cart',['CartItemSum'])
		})
    },
}
</script>

<style lang="sass">
$MainColor: #FFCBBB
$DarkMainColor: #b25437

@mixin FlexSetting($justify-content:center, $align-items:center)
	display: flex
	justify-content: $justify-content
	align-items: $align-items
.Navbar
	+FlexSetting(space-between, center)
	background-color: #fff
	border-bottom: 2px solid $MainColor
	box-shadow: 0px 5px 10px rgba(#ccc, 0.5)
	height: 60px
	width: 100%
	z-index: 50
	position: fixed
	top: 0
	.Navbar_logo
		+FlexSetting(flex-start, center)
		height: 100%
		width: 120px
		background-image: url('../assets/img/Logo.png')
		background-size: cover
	.Navbar_item
		ul
			+FlexSetting(flex-end ,center)
			margin-bottom: 0px
			height: 60px
			li 
				font-size: 18px
				letter-spacing: 2px
				height: 100%
				color: #000
				height: 100%
				line-height: 60px
				padding: 0px 10px				
				a 
					text-decoration: none
					color: #000
					&:hover
					cursor: pointer
					text-decoration: none
				&:hover
					cursor: pointer
					text-decoration: none
					background-color: $DarkMainColor
					color: #fff		
					
								
			.cart
				position: relative
				.cartsums

</style>



// WEBPACK FOOTER //
// src/components/narbar.vue